import { useEffect, useState } from "react";

const ROOT_ID = "root";

const rootHidden = () => document.getElementById(ROOT_ID)?.getAttribute("aria-hidden") === "true";

/**
 * Whether any MUI modal is open (TT-1231): a Dialog, a Menu, a Popover. MUI
 * portals them beside the app root and marks the root `aria-hidden` while
 * one is up, so that one attribute is the whole app's modal state, with no
 * page having to report its own.
 */
export default function useModalOpen() {
  const [open, setOpen] = useState(rootHidden);
  useEffect(() => {
    const root = document.getElementById(ROOT_ID);
    if (!root) return undefined;
    const observer = new MutationObserver(() => setOpen(rootHidden()));
    observer.observe(root, { attributes: true, attributeFilter: ["aria-hidden"] });
    return () => observer.disconnect();
  }, []);
  return open;
}
